<!-- @format -->

<template>
  <div class="form-div">
    <alert-box
      :alertText="errMsg"
      :alertType="errType"
      v-if="alert"
    ></alert-box>
    <teleport to="#app">
      <confirm-box ref="confirm"></confirm-box>
      <MessageBox ref="msgbox"></MessageBox>
      <popup-loader
        :LoaderText="'Please wait..'"
        v-if="ispopupLoading == true"
      ></popup-loader>
    </teleport>
    <div class="title-bar">
      <div class="title-text">Class Messages</div>
      <div class="close-btn">
        <router-link to="/dashboard">
          <span class="fas fa-times-circle"></span
        ></router-link>
      </div>
    </div>
    <div class="content-area">
      <div class="filter-area">
        <div class="user-filter"></div>
        <div class="row class-filter">
          <div class="col-sm-2">
            <label for="class">Class <MandatoryPage /> </label>
            <select
              name="cldes"
              class="form-select"
              v-model="cmbclass"
              tabindex="2"
              ref="class"
              @blur="getSections"
              :disabled="!showfilter"
            >
              <option :value="''">--Select--</option>
              <option
                v-for="item in classesList"
                :key="item.class"
                :value="item"
              >
                {{ item.cldes }}
              </option>
            </select>
          </div>
          <div class="col-sm-2">
            <label for="sec">Section <MandatoryPage /></label>
            <select
              name="sec"
              class="form-select"
              v-model="formData.sec"
              tabindex="2"
              ref="sec"
              :disabled="!showfilter"
            >
              <option :value="''">--All--</option>
              <option
                v-for="item in sectionsList"
                :key="item.sec"
                :value="item.sec"
              >
                {{ item.sec }}
              </option>
            </select>
          </div>
          <div class="col-sm-2">
            <label for="sub">Subjects </label>
            <select
              name="sub"
              class="form-select"
              v-model="cmbsub"
              tabindex="2"
              ref="sub"
              :disabled="!showfilter"
            >
              <option :value="''">--All--</option>
              <option
                v-for="item in subjectList"
                :key="item.scode"
                :value="item"
              >
                {{ item.sname }}
              </option>
            </select>
          </div>
          <div class="col-sm-2">
            <label for="prd">Periods </label>
            <select
              name="prd"
              class="form-select"
              v-model="cmbprd"
              tabindex="2"
              ref="prd"
              :disabled="!showfilter"
            >
              <option :value="''">--Select--</option>
              <option v-for="item in periodList" :key="item" :value="item">
                {{ item }}
              </option>
            </select>
          </div>
          <div class="col-sm-4">
            <label for="clmsg">Message <MandatoryPage /></label>
            <select
              name="clmsg"
              class="form-select"
              v-model="combomsg"
              tabindex="2"
              ref="clmsg"
              @change="selectMessage"
              :disabled="!showfilter"
            >
              <option :value="''">--All--</option>
              <option v-for="item in msgList" :key="item.id" :value="item">
                {{ item.msg }}
              </option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <span class="selectedmsg">{{ formData.selected_msg.msg }}</span>
          </div>
        </div>

        <div class="filter-btns" v-if="showfilter == true">
          <button type="button" class="btn btn-primary" @click="filterRec">
            Filter
          </button>
          &nbsp;&nbsp;&nbsp;
          <button type="button" class="btn btn-primary" @click="clearFilter">
            Clear Filter
          </button>
        </div>
        <div class="send-btns" v-else>
          <span class="student-count">{{
            selectedStudents.length + " Students Selected"
          }}</span>
          <button type="button" class="btn btn-success" @click="sendMsg()">
            Send Message
          </button>
          &nbsp;&nbsp;&nbsp;
          <button type="button" class="btn btn-danger" @click="cancelMsg()">
            Cancel
          </button>
        </div>

        <input
          type="text"
          class="form-control searchbox"
          placeholder="Search"
          v-model="search"
          ref="search"
          autofocus
        />
      </div>
      <div class="grid-area" v-if="showfilter == false">
        <CardLoader :LoaderText="loadertext" v-if="loading == true" />
        <div v-else class="students-list">
          <div class="student-table-div">
            <div class="hide-table" v-if="hidetable == true"></div>
            <table>
              <thead>
                <tr>
                  <th>Roll No.</th>
                  <th>Student Name</th>
                  <th>Father Name</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="stu in studentList"
                  :key="stu.glc"
                  @click="selectStudent(stu)"
                  :class="stu.selected == true ? 'studentselect' : ''"
                >
                  <td>{{ stu.rollno }}</td>
                  <td>{{ stu.gln }}</td>
                  <td>{{ stu.fname }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertBox from "@/components/AlertBox.vue";
import CardLoader from "@/components/CardLoader.vue";
import ConfirmBox from "@/components/ConfirmBox.vue";
import axios from "axios";
import MyFun from "@/js/MyFun";
import MessageBox from "@/components/MessageBox.vue";
import PopupLoader from "../../components/PopupLoader.vue";

export default {
  components: {
    AlertBox,
    CardLoader,
    ConfirmBox,
    MessageBox,
    PopupLoader,
  },
  data() {
    return {
      formId: "011",
      permission: [],
      classesList: [],
      sectionsList: [],
      studentArr: [],
      periodList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      subjectList: [],
      cmbclass: "",
      cmbsec: "",
      cmbsub: "",
      cmbprd: "",
      combomsg: "",
      choosenmsg: "",
      addForm: false,
      optn: "Add",
      hidetable: false,
      showfilter: true,
      ispopupLoading: false,
      search: "",
      mstList: [],
      userId: this.$store.state.userId,
      userName: this.$store.state.userName,
      errMsg: "",
      errType: "",
      alert: false,
      loading: true,
      ecode: "",
      mdate1: MyFun.getdtnow(),
      mdate2: MyFun.getdtnow(),
      loadertext: "Please Wait..",
      selectedStudents: [],
      msgList: [],
      formData: {
        msgtype: "3", //To a Student only Category
        docno: "",
        class: "",
        cldes: "",
        class1: "",
        sec: "",
        prd: "",
        msubject: "Class Message",
        selected_msg: {
          id: "",
          msg: "",
        },
        ecode: "",
        ename: this.$store.state.userName,
        scode: "",
        sname: "",
        selectedstudents: [],
      },
    };
  },
  methods: {
    async filterRec() {
      this.formData.prd = this.cmbprd;
      this.formData.scode =
        this.cmbsub.scode == undefined ? "" : this.cmbsub.scode;
      this.formData.sname =
        this.cmbsub.sname == undefined ? "" : this.cmbsub.sname;

      this.formData.selected_msg.id = this.combomsg.id;
      this.formData.selected_msg.msg = "";

      if (this.cmbprd != "") {
        this.formData.selected_msg.msg =
          this.formData.selected_msg.msg + "Period:" + this.cmbprd + "\n";
      }

      if (this.formData.sname != "") {
        this.formData.selected_msg.msg =
          this.formData.selected_msg.msg +
          "Subject:" +
          this.formData.sname +
          "\n ";
      }
      this.formData.selected_msg.msg =
        this.formData.selected_msg.msg + this.combomsg.msg;
      // newmessage =

      //   mymsg;
      if (
        this.formData.class == "" ||
        this.formData.scode == undefined ||
        this.formData.sec == "" ||
        this.combomsg.id == "" ||
        this.combomsg.id == undefined ||
        this.combomsg.msg == "" ||
        this.combomsg.msg == undefined
      ) {
        this.$refs.msgbox.show({
          title: "Alert",
          message: "Please select all  mandatory boxes!",
          okButton: "OK",
          msgboxType: "danger",
        });
      } else {
        this.showfilter = false;
        this.loading = true;
        this.selectedStudents = [];
        this.formData.selectedstudents = [];
        await this.getStudents();
        this.loading = false;
      }
    },
    clearFilter() {
      this.ecode = "";
      this.cmbclass = "";
      this.cmbsec = "";
      this.cmbsub = "";
      this.cmbprd = "";
      this.cmbmsg = "";
      this.formData.sec = "";
      this.formData.scode = "";
      this.formData.sname = "";
      this.formData.class = "";
      this.formData.cldes = "";
      this.formData.class1 = "";
      this.selectedStudents = [];
      this.formData.selectedstudents = [];
    },
    selectMessage() {
      this.formData.selected_msg.id = this.combomsg.id;
      this.formData.selected_msg.msg = this.combomsg.msg;
    },
    showAlert(xtime = 1500) {
      this.alert = true;
      setTimeout(() => {
        this.alert = false;
      }, xtime);
    },
    async getStudents() {
      this.loading = true;
      await axios
        .post("glmast.php", {
          optn: "GetStudents",
          class: this.formData.class,
          class1: this.formData.class1,
          sec: this.formData.sec,
        })
        .then((resp) => {
          this.loading = false;
          this.studentArr = [];
          if (resp.data.Error == false) {
            var myarr = resp.data.List;
            this.studentArr = myarr.map((item) => ({
              ...item,
              selected: false,
            }));
          } else {
            console.log(resp);
          }
        });
    },
    selectStudent(obj) {
      this.studentArr.map((rw) => {
        if (rw.glc == obj.glc) {
          if (rw.selected == true) {
            var idx = this.selectedStudents.findIndex((r) => {
              return r == obj.glc;
            });
            if (idx >= 0) {
              this.selectedStudents.splice(idx, 1);
              rw.selected = false;
            }
          } else {
            this.selectedStudents.push(obj.glc);
            rw.selected = true;
          }
        }
      });
      this.formData.selectedstudents = this.selectedStudents;
    },
    async sendMsg() {
      if (this.selectedStudents.length <= 0) {
        this.$refs.msgbox.show({
          title: "Alert",
          message: "Please Select Student!",
          okButton: "OK",
          msgboxType: "warn",
        });
      } else {
        this.ispopupLoading = true;
        await axios
          .post("teachermsg.php", {
            optn: "SendMessage",
            frmdata: this.formData,
            userid: this.userId,
            username: this.userName,
          })
          .then((response) => {
            this.ispopupLoading = false;
            if (response.data.Error == true) {
              this.$refs.msgbox.show({
                title: "Alert",
                message: "Something Went Wrong!" + response.data.ErrorMsg,
                okButton: "OK",
                msgboxType: "danger",
              });
            } else {
              this.$refs.msgbox.show({
                title: "Message Sent",
                message: "Message Sent Successfully!",
                okButton: "OK",
                msgboxType: "success",
              });
              this.cancelMsg();
            }
          });
      }
    },
    cancelMsg() {
      this.showfilter = true;
    },
    async getClasses() {
      await axios
        .post("classes.php", {
          optn: "Classes",
          userid: this.userId,
          isteacher: this.$store.state.isTeacher,
        })
        .then((response) => {
          var resp = response.data;
          if (resp.Errorsts == false) {
            this.classesList = resp.List;
          } else {
            console.log("Error:" + resp.ErrorMsg);
          }
        });
    },
    async getSections() {
      if (this.cmbclass == "") {
        this.formData.class = "";
        this.formData.cldes = "";
        this.formData.class1 = "";
      } else {
        this.formData.class = this.cmbclass.class;
        this.formData.cldes = this.cmbclass.cldes;
        this.formData.class1 = this.cmbclass.class1;
        this.formData.cmbsub = "";
        await this.getSubjects();
        this.formData.scode = "";
        this.formData.sname = "";

        await axios
          .post("classes.php", {
            optn: "Classec",
            class: this.formData.class,
            cldes: this.formData.cldes,
            class1: this.formData.class1,
          })
          .then((response) => {
            var resp = response.data;
            if (resp.Errorsts == false) {
              this.sectionsList = resp.List;
              this.formData.sec = "";
            } else {
              console.log("Error:" + resp.ErrorMsg);
            }
          });
      }
    },
    async getSubjects() {
      await axios
        .post("subjects.php", {
          optn: "SubjectsList",
          mclass: this.formData.class,
          mclass1: this.formData.class1,
        })
        .then((resp) => {
          if (resp.data.Error == false) {
            this.subjectList = resp.data.List;
          } else {
            console.log("Error Occured!");
          }
        });
    },
    async getMessages() {
      this.msgList = [];
      var mymsg = [];
      await axios
        .post("teachermsg.php", {
          optn: "GetTemplateMsg",
        })
        .then((resp) => {
          if (resp.data.Errorsts == false) {
            var myarr = resp.data.List;
            mymsg = myarr.map((r) => ({
              id: r.id,
              selected: Boolean(r.selected),
              msg: r.msg,
            }));
            this.msgList = mymsg;
          } else {
            console.log(resp);
          }
        });
    },
  },
  async mounted() {
    await this.getClasses();
    console.log("Getting Messages...");
    await this.getMessages();
    // await this.clearFilter();
  },
  computed: {
    studentList() {
      return this.studentArr.filter((rw) => {
        var mystr = rw.gln.trim() + rw.fname.trim();
        return mystr.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
};
</script>

<style scoped>
.selectedmsg {
  position: relative;
  font-size: 22px;
  font-weight: bold;
}

.studentselect {
  background-color: lightskyblue;
}
.send-btns {
  position: relative;
  text-align: right;
  margin-top: 5px;
  margin-bottom: 5px;
}

.student-count {
  position: relative;
  margin-right: 10px;
  font-size: 12px;
  font-weight: bold;
}
.message-div {
  position: relative;
  display: block;
  width: calc(100% - 10px);
  padding: 15px;
  border-radius: 10px;
  margin-bottom: 10px;
  border: 1px solid lightgray;
}
.message-div .subject {
  position: relative;
  font-weight: bold;
}

.message-div .srno {
  position: relative;
  margin-left: 2px;
  margin-right: 2px;
}
.message-div .grade {
  position: relative;
  display: block;
  font-weight: 600;
  font-size: 14px;
  margin-left: 18px;
}
.message-div .message {
  position: relative;
  display: block;
  margin-left: 18px;
  line-height: 18px;
}
.message-div .sender-detail {
  position: relative;
  display: block;
}
.message-div .sender-detail .sendedby {
  position: relative;
  display: block;
  font-size: 12px;
  text-align: right;
  font-weight: bolder;
  margin-top: 10px;
}
.message-div .sender-detail .senton {
  position: relative;
  display: block;
  font-size: 12px;
  text-align: right;
  font-weight: bolder;
}

.message-div .icon-div {
  position: relative;
  display: block;
  width: 100%;
}
.message-div .icon-div .fa-trash {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.message-div .icon-div .fa-paperclip {
  position: relative;
  display: inline-block;
  font-size: 18px;
  margin-left: 8px;
  top: 2px;
  cursor: pointer;
}

.message-div .icon-div .fa-paperclip:hover {
  position: relative;
  color: gray;
}
.message-div .icon-div .fa-eye {
  position: relative;
  display: inline-block;
  cursor: pointer;
  margin-left: 8px;
}
.message-div .icon-div .fa-eye:hover {
  color: rgb(94, 94, 243);
}

.form-div {
  position: relative;
  margin: 5px;
  padding: 0px;
  width: calc(100% - 10px);
  border-radius: 5px;
  background-color: white;
  border: 1px solid lightgray;
  top: 10px;
}

.title-bar {
  position: relative;
  display: block;
  padding: 10px;
  width: 100%;
  background-color: #242424;
  color: whitesmoke;
  font-weight: bold;
  text-align: left;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.title-bar div {
  display: inline-block;
}
.close-btn {
  position: relative;
  justify-content: right;
  right: 0px;
  float: right;
  cursor: pointer;
}
.close-btn a {
  position: relative;
  color: white;
  font-size: 20px;
  top: -3px;
}
.close-btn a:hover {
  color: red;
}
.content-area {
  padding: 15px;
}

.btn-area {
  position: relative;
  display: block;
  padding: 5px;
}
.btn-area .exportbtn {
  position: relative;
  float: right;
}

.filter-area {
  padding: 5px;
}

.grid-area {
  padding: 2px;

  width: 100%;
  background-color: white;
  max-height: calc(100vh - (250px));
  overflow: auto;
}
.grid-area table {
  width: 100%;
}
.grid-area table thead {
  position: sticky;
  top: 0px;
  background-color: #242424;
  color: white;
}
.grid-area table tfoot {
  position: sticky;
  bottom: 0px;
  background-color: #242424;
  color: white;
}

.grid-area table thead tr th {
  font-weight: 400;
  padding: 5px;
}

.grid-area table tbody tr td {
  cursor: pointer;
  padding: 5px;
  border-bottom: 0.5px solid lightgray;
}
.grid-area table tbody tr:hover {
  background-color: lightgray;
}

.editcol {
  width: 80px;
}
.srnocol {
  width: 60px;
}

.smalldt {
  position: relative;
  display: block;
  font-size: xx-small;
  font-weight: bold;
}

.dt-filter {
  position: relative;
  display: block;
  font-size: 11px;
  font-weight: bold;
  margin: 0px;
}
.dt-filter label {
  position: relative;
  display: inline-block;
  margin-top: 5px;
  width: 80px;
  left: 4px;
}
.dt-filter .form-control {
  position: relative;
  font-size: 11px;
  font-weight: bold;
  width: 150px;
  display: inline-block;
  margin-bottom: 5px;
}

.dt-filter .form-select {
  position: relative;
  font-size: 11px;
  font-weight: bold;
  width: 250px;
  display: inline-block;
  margin-bottom: 5px;
}

.class-filter {
  margin-top: 0px;
}
.class-filter .col-sm-2 {
  margin-top: 0px;
}
.class-filter .form-select {
  position: relative;
  font-size: 11px;
  margin-bottom: 5px;
}

.class-filter label {
  position: relative;
  font-size: 13px;
  font-weight: bold;
}
.user-filter {
  position: relative;
  display: block;
  font-size: 11px;
  font-weight: bold;
  margin: 0px;
}

.user-filter label {
  position: relative;
  display: inline-block;
  margin-top: 5px;
  width: 80px;
}

.user-filter .form-control {
  position: relative;
  font-size: 11px;
  font-weight: bold;
  display: inline-block;
  margin-bottom: 5px;
}

.filter-btns {
  position: relative;
  display: block;
  margin-bottom: 8px;
}

@media only screen and (max-width: 600px) {
  .grid-area {
    margin-top: 15px;
  }
  .grid-area table thead tr th,
  .grid-area table tbody tr td,
  .grid-area table tfoot tr td {
    padding: 2px;
    font-size: 12px;
  }

  .dt-filter label {
    position: relative;
    display: block;
    width: 80px;
  }
  .dt-filter .form-control {
    position: relative;
    display: block;
    font-size: 11px;
    font-weight: bold;
    width: 100%;
    display: inline-block;
  }

  .dt-filter .form-select {
    position: relative;
    font-size: 11px;
    font-weight: bold;
    width: 100%;
    display: inline-block;
    margin-bottom: 5px;
  }
}
</style>
